import { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddTargetSystem from "./hooks/useAddTargetSystem";
import useTargetSystem from "./hooks/useTargetSystem";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateTargetSystem } from "./atoms/atoms";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";

const TargetSystemForm = () => {
  //Hooks
  const AddTargetSystem = useAddTargetSystem();
  const { data } = useTargetSystem();
  //Recoils Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateTargetSystem);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasTargetSystem, setHasTargetSystem] = useState(false);

  const defaulValues = {
    targetSystemId: 0,
    targetSystemName: "",
    description: "",
    createdBy: "",
    createdDate: null,
    isActive: 0,
  };
  const [emptypeNewData] = useState([defaulValues]);
  const [targetSystemExist, settargetSystemExist] = useState(false);

  const handleAddTargetSystem = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    inputvalue = inputvalue.trim();
    if (SourceType === "addTargetSystem") {
      if (fieldName === "targetSystemName") {
        const result = data?.filter(
          (item) =>
            item.targetSystemName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        if (result === undefined) {
          emptypeNewData.map((x) => (x.targetSystemName = inputvalue));
          settargetSystemExist(false);
        } else {
          settargetSystemExist(true);
        }
        inputvalue === ""
          ? setHasTargetSystem(false)
          : setHasTargetSystem(true);
      }
      if (fieldName === "description") {
        emptypeNewData.map((x) => (x.description = inputvalue));
      }
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    if (changed) {
      if (!targetSystemExist) {
        if (
          emptypeNewData.filter((x) => x.targetSystemName) !== "" &&
          emptypeNewData.filter((x) => x.description) !== ""
        ) {
          //call Insert
          AddTargetSystem(emptypeNewData);
          setActionAddState(!actionAddState);
          setOpenModal(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModal(false);
        }
      } else {
        toast.fire(
          "Saving Failed",
          "Policy Management System already exists!",
          "error"
        );
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Policy Management System Name",
      field: "targetSystemName",
      render: (rowData) => {
        return (
          <div className="grid grid-cols-1">
            <div className="">
              <TextInput
                defaultValue={rowData.targetSystemName}
                onChange={(e) =>
                  handleAddTargetSystem(
                    "addTargetSystem",
                    "targetSystemName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Description",
      field: "description",
      render: (rowData) => {
        return (
          <div className="grid grid-cols-1">
            <div className="">
              <TextInput
                defaultValue={rowData.description}
                onChange={(e) =>
                  handleAddTargetSystem(
                    "addTargetSystem",
                    "description",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Policy Management System"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="px-2 pt-2 pb-2 space-y-2 border-l-2 border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Policy Management System
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasTargetSystem ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasTargetSystem}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                }}
              />
            </div>
          </div>
          <div className="h-0.5 w-full border-b-2 border-secondary "></div>
          <div className="space-y-5 space-x-2 space-y-20 w-full ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="py-2"></div>
        </div>
      </div>
    </div>
  );
};

export default TargetSystemForm;
